import { combineReducers } from 'redux';
import logs from './logs';
import fetching from './fetching';

export default combineReducers({
  fetching,
  logs,
});
